import { render, staticRenderFns } from "./CrisisScenarioIcon.vue?vue&type=template&id=47784eec&scoped=true"
import script from "./CrisisScenarioIcon.vue?vue&type=script&lang=js"
export * from "./CrisisScenarioIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47784eec",
  null
  
)

export default component.exports